<form [formGroup]="form.formGroup">

  <p-toolbar>
    <ng-template #start></ng-template>
    <ng-template #end>
      <div class="flex items-center">
        <svg-icon
          src="../../assets/icons/reset-default-24x24.svg"
          class="w-[25px] h-[25px] tree-icon cursor-pointer"
          (click)="applyDefaults()"
          title="Apply Defaults">
        </svg-icon>
      </div>
    </ng-template>
  </p-toolbar>

  <div class="mt-2">

    <p-fieldset legend="Volumetric Composition">
      <div class="flex flex-col space-y-2">

        <div class="flex flex-col">
          <label for="baseBrine">Base Water</label>
          <p-inputgroup>
            <p-select [disabled]="isReadOnly" [options]="brines" [formControlName]="form.formControlNames.baseBrine"
              optionLabel="state.name" appendTo="body">
            </p-select>
            <app-validated-number-input
              [id]="'waterFraction'"
              [control]="control('waterFraction')"
              [value]="control('waterFraction').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('waterFraction', $event)"
              [unit]="'%'"
            ></app-validated-number-input>
          </p-inputgroup>
        </div>

        <div class="flex flex-col">
          <label for="baseOil">Base Oil</label>
          <p-inputgroup>
            <p-select [disabled]="isReadOnly" [options]="baseOilTypes" [formControlName]="form.formControlNames.baseOil"
              optionLabel="name" optionValue="value" appendTo="body"></p-select>
            <app-validated-number-input
              [id]="'oilFraction'"
              [control]="control('oilFraction')"
              [value]="control('oilFraction').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('oilFraction', $event)"
              [unit]="'%'"
            ></app-validated-number-input>
          </p-inputgroup>
        </div>

        <div class="flex flex-col">
          <label for="highDensitySolids">High Density Solids</label>
          <p-inputgroup>
            <p-select [disabled]="isReadOnly" [options]="highDensityMudSolidsTypes"
              [formControlName]="form.formControlNames.highDensityMudSolidsType" optionLabel="name" optionValue="value"
              appendTo="body"></p-select>
            <app-validated-number-input
              [id]="'highDensitySolidsFraction'"
              [control]="control('highDensitySolidsFraction')"
              [value]="control('highDensitySolidsFraction').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('highDensitySolidsFraction', $event)"
              [unit]="'%'"
            ></app-validated-number-input>
          </p-inputgroup>
        </div>

        <div class="flex flex-col">
          <label for="lowDensitySolids">Low Density Solids</label>
          <p-inputgroup>
            <p-select [disabled]="isReadOnly" [options]="lowDensityMudSolidsTypes"
              [formControlName]="form.formControlNames.lowDensityMudSolidsType" optionLabel="name" optionValue="value"
              appendTo="body"></p-select>
            <app-validated-number-input
              [id]="'lowDensitySolidsFraction'"
              [control]="control('lowDensitySolidsFraction')"
              [value]="control('lowDensitySolidsFraction').value"
              [validation]="{ min: 0, max: 100 }"
              (onChange)="validatePercentage('lowDensitySolidsFraction', $event)"
              [unit]="'%'"
            ></app-validated-number-input>
          </p-inputgroup>
        </div>

        <div class="mr-2">
          <p>Total: {{ totalPercent }} %</p>
        </div>

        @if (totalPercent !== 100) {
          <p class="validation-error mb-2">Total percent must be equal to 100%</p>
        }

        <div class="flex flex-col">
          <label for="densityTemperature">Density Temperature</label>
          <app-validated-number-input
            [id]="'densityTemperature'"
            [control]="control('densityTemperature')"
            [value]="control('densityTemperature').value"
            [validation]="temperatureValidation"
            [unit]="tempUnit"
          ></app-validated-number-input>
          @if (form.formGroup.controls.nominalDensity.value) {
            <p class="text-sm pt-3">Density: {{form.formGroup.controls.nominalDensity.value | number : "1.0-2" }} {{ densityUnit }}</p>
          }
        </div>
      </div>

    </p-fieldset>

    <div class="flex align-center mr-2 mt-2 mb-2">
      <label class="mr-2">Show Base Oil Correlations</label>
      <p-toggleswitch (onChange)="showBaseOils()"></p-toggleswitch>
    </div>

    @if (showBaseOil) {
    <p-fieldset legend="Base Oil Density Correlation">
      <div class="flex gap-2">
        <div class="flex flex-col w-1/2 gap-2">
          <div class="flex flex-col">
            <label for="a0" class="mb-1">a0 x 10<span class="text-xs align-super">4</span></label>
            <input disabled="true" pInputText value="{{ a0 }}" required />
          </div>
          <div class="flex flex-col">
            <label for="a1" class="mb-1">a1 x 10<span class="text-xs align-super">8</span></label>
            <input disabled="true" pInputText value="{{ a1 }}" required />
          </div>
          <div class="flex flex-col">
            <label for="a2" class="mb-1">a2 x 10<span class="text-xs align-super">13</span></label>
            <input disabled="true" pInputText value="{{ a2 }}" required />
          </div>
        </div>
        <div class="flex flex-col w-1/2 gap-2">
          <div class="flex flex-col">
            <span><label for="b0" class="mb-1">b0 x 10</label></span>
            <input disabled="true" pInputText value="{{ b0 }}" required />
          </div>
          <div class="flex flex-col">
            <label for="b1" class="mb-1">b1 x 10<span class="text-xs align-super">6</span></label>
            <input disabled="true" pInputText value="{{ b1 }}" required />
          </div>
          <div class="flex flex-col">
            <label for="b2" class="mb-1">b2 x 10<span class="text-xs align-super">12</span></label>
            <input disabled="true" pInputText value="{{ b2 }}" required />
          </div>
        </div>
      </div>
    </p-fieldset>
    }

    <div class="mt-2 mb-2">

      <p-fieldset legend="Rheology">

        <div class="flex flex-col">
          <label for="plasticViscosity">Plastic Viscosity</label>
          <app-validated-number-input
            [id]="'plasticViscosity'"
            [control]="control('plasticViscosity')"
            [value]="control('plasticViscosity').value"
            [validation]="pvValidation"
            [unit]="pvUnits"
          ></app-validated-number-input>
        </div>

        <div class="flex flex-col">
          <label for="yieldPoint">Yield Point</label>
          <app-validated-number-input
            [id]="'yieldPoint'"
            [control]="control('yieldPoint')"
            [value]="control('yieldPoint').value"
            [validation]="ypValidation"
            [unit]="ypUnits"
          ></app-validated-number-input>
        </div>

        <div class="flex flex-col">
          <label for="rheologyTemperature">Temperature</label>
          <app-validated-number-input
            [id]="'rheologyTemperature'"
            [control]="control('rheologyTemperature')"
            [value]="control('rheologyTemperature').value"
            [validation]="temperatureValidation"
            [unit]="tempUnit"
          ></app-validated-number-input>
        </div>

      </p-fieldset>

    </div>
  </div>

</form>
